import React from 'react';
import SortByDropdown from './SortByDropdown';
import PropTypes from 'prop-types';
import { PaginationPropShape } from '../Infrastructure/propShapes';
import { translateResourceString } from '../../util/translationUtility';

class PaginationContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        require('./PaginationContainer.css');
    }

    getPaginationRange = (pagination) => {
        if (pagination.resultsTotal <= pagination.currentItemsOnPage) {
            return `1-${pagination.resultsTotal}`;
        } else {
            const startRange = this.props.paginationFirstItemIndex + 1;
            const endRange = Math.min(startRange + pagination.currentItemsOnPage - 1, pagination.resultsTotal);
            return `${startRange}-${endRange}`;
        }
    };

    getActiveFilters = (attributes) => {
        return attributes.map(attr => ({
            ...attr,
            values: attr.values.filter(value => value.checked)
        }));
    };

    clearFilter = (attrName, filterName) => {
        this.props.onAttributeChange(attrName, filterName);
    };

    render() {
        const {
            pagination,
            onCurrentSortByChange,
            onShowMobileFacetsToggle,
            showClearAttributes,
            onClearAttributes,
            onAttributeChange,
            attributes,
            useLoadMoreButton,
            alwaysShowResultsTotal
        } = this.props;

        const paginationRange = this.getPaginationRange(pagination);

        const activeFilters = this.getActiveFilters(attributes);

        return (
            <div className="row pagination-container">

                <div className="col-6">
                    <div className="pagination-container__filters product-list__wrapper">
                        {onShowMobileFacetsToggle &&
                            <a
                                className="d-lg-none btn btn-filters"
                                onClick={onShowMobileFacetsToggle}
                                href="javascript:none">
                                <i className="fa fa-filter"></i> {translateResourceString("/Search/Filters")}
                            </a>
                        }

                        {/*<div className="float-left d-none d-md-block">*/}
                        {/*    Filters*/}
                        {/*</div>*/}

                        {showClearAttributes &&
                            <span
                                onClick={onClearAttributes}
                                className="pull-right filter clear-all-filters"
                            >
                                {translateResourceString("/Search/ClearAll")}
                                <i className="icon-close"></i>
                            </span>
                        }

                        {
                            activeFilters.map(attr => (
                                attr.values.map(filter => (
                                    <span className="filter clear-all-filters"
                                        key={filter.name}
                                        onClick={(e) => { this.clearFilter(attr.name, filter.name) }}>
                                        {filter.displayName}
                                        <i className="icon-close"></i>
                                    </span>
                                ))
                            ))
                        }
                    </div>
                </div>

                {pagination.sortOptions &&
                    <div className="col-6">
                        <div className="row flex-lg-row-reverse">
                            <div className="col-12 col-xl-8 pagination-dropdown-wrapper">
                                <SortByDropdown sortOptions={pagination.sortOptions} onCurrentSortByChange={onCurrentSortByChange} />
                            </div>
                            {useLoadMoreButton || alwaysShowResultsTotal
                                ? <div className="col-12 col-xl-4 results-count">
                                    {translateResourceString("/Search/Results")} {pagination.resultsTotal}
                                </div>
                                : <div className="col-12 col-xl-4 results-count">
                                    {translateResourceString("/Search/Results")} {paginationRange} {translateResourceString("/Search/Of")} {pagination.resultsTotal}
                                </div>
                            }
                        </div>
                    </div>
                }

            </div>
        );
    }
}

PaginationContainer.propTypes = { ...PaginationPropShape };

export default PaginationContainer;